import { createNodeId } from '../render/node-id';
const ICON_BOX_SIZE = Object.freeze({
    sm: '1rem',
    md: '1.5rem',
});
export function createIconNode(definition, props) {
    const { size = 'md', customSize, className, 'data-icon': dataIcon, color = 'currentColor', } = props;
    const iconDefinition = definition[size];
    const boxSize = customSize !== undefined
        ? `${customSize * 0.25}rem`
        : ICON_BOX_SIZE[size];
    const iconProps = {
        width: boxSize,
        height: boxSize,
        viewBox: iconDefinition.viewBox,
        fill: 'none',
        xmlns: 'http://www.w3.org/2000/svg',
        ...(dataIcon && { 'data-icon': dataIcon }),
        ...(className && { className }),
    };
    return {
        id: createNodeId(),
        type: 'svg',
        props: iconProps,
        children: iconDefinition.paths.map((path) => ({
            id: createNodeId(),
            type: 'd' in path ? 'path' : 'circle',
            props: resolvePathProps(path, color),
            children: [],
        })),
    };
}
function resolvePathProps(path, color) {
    return {
        ...path,
        ...(path.fill === 'currentColor' && { fill: color }),
        ...(path.stroke === 'currentColor' && { stroke: color }),
    };
}
//# sourceMappingURL=create-icon.js.map